import request from "../../service/httpService";
import { updateField, getField } from "vuex-map-fields";

export default {
    namespaced: true,
    state() {
        return {
            id: 0,
            friendly_name: '',
            room: '',
            serial: '',
            model: '',
            appliance: { history: [] },
        }
    },
    mutations: {
        updateField,
        setAppliance(state, payload) {
            state.friendly_name = payload.friendly_name;
            state.room = payload.room;
            state.serial = payload.serial;
            state.appliance = payload;
        },
        setApplianceHistory(state, payload) {
            state.appliance.history = payload;
        },
        setId(state, payload) {
            state.id = payload;
        }
    },
    getters: {
        getField,
        friendly_name: state => state.friendly_name,
        appliance: state => state.appliance,
        history: state => state.appliance.history,
        id: state => state.id
    },
    actions: {
        async fetch({ commit }, id) {
            const response = await request('get', 'appliances', `/${id}`,
                {
                    populate: 'history,appliance_type,appliance_type.media,appliance_type.capabilities.capability.labels'
                });
            //console.log(response);
            commit('appliance_capabilities/setCapabilities', response.data.attributes.appliance_type.data.attributes.capabilities.data, { root: true });
            commit("setAppliance", response.data.attributes);
            commit("setId", id);
        },
        async command({ commit, state, getters }, command) {
            return new Promise((resolve) => {
                let history = [...getters.history];
                // Elimina l'id dell'oggetto
                history = history.map((item) => {
                    return {
                        start_time: item.start_time,
                        end_time: item.end_time,
                        payload: item.payload,
                        capability: item.capability
                    }
                });
                history.push(command);

                request('put', 'appliances', `/${state.id}`, {}, {
                    data: {

                        history
                    }
                }).then(() => {
                    commit("setApplianceHistory", history);
                    resolve(true);
                }
                    );
                
            })


        }
    }
};